/** Number of consecutive page indices shown at once (fixed-width pager window). */
export const VISIBLE_PAGE_BUTTON_COUNT = 3

export function getVisiblePageNumbers(
  totalPages: number,
  currentPage: number,
): number[] {
  if (totalPages <= VISIBLE_PAGE_BUTTON_COUNT) {
    return Array.from({ length: totalPages }, (_, index) => index + 1)
  }

  const maxStart = totalPages - VISIBLE_PAGE_BUTTON_COUNT + 1
  const start = Math.min(Math.max(currentPage - 1, 1), maxStart)

  return Array.from(
    { length: VISIBLE_PAGE_BUTTON_COUNT },
    (_, index) => start + index,
  )
}
